import CatalogoTratamientoABM from "./CatalogoTratamientoABM";
export default function AddInstitucionesSeguimientoTratamiento() {
  return <CatalogoTratamientoABM endpoint="/instituciones-seguimiento-tratamiento" idField="IdInstitucionSeguimientoTratamiento" titulo="Agregar institución de seguimiento de tratamiento" nombreCampo="Nombre de la institución" />;
}
